import React, { useEffect, useRef } from "react";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import AccordionDetails from "@mui/material/AccordionDetails";
import TextField from "@mui/material/TextField";
import AccordionActions from "@mui/material/AccordionActions";
import DeleteIcon from "@mui/icons-material/Delete";
import Accordion from "@mui/material/Accordion";
import { makeStyles } from "tss-react/mui";
import * as PropTypes from "prop-types";
import { DragHandle } from "@mui/icons-material";
import IntentButton, { Intent } from "../input/intent-button";
import { MethodStep } from "../../types";

const useStyles = makeStyles()((theme) => ({
  step: {
    marginTop: "4px",
    padding: "4px",
    whiteSpace: "pre-wrap",
    width: "100%",
    minHeight: "30px",
  },

  stepSummary: {
    marginLeft: "10px",
    color: theme.palette.grey["600"],
    whiteSpace: "nowrap",
    flexShrink: 0,
  },

  summaryContent: {
    minWidth: 0,
    marginLeft: "8px",
  },

  stepPreviewContainer: {
    overflow: "hidden",
    flex: 1,
    minWidth: 0,
  },

  stepPreview: {
    padding: "0 5px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: theme.palette.grey["500"],
  },
}));

interface Props {
  step: MethodStep;
  stepName: string;
  expanded: boolean;
  editMode: boolean;
  handleExpansionChange: (id: string, isExpanded: boolean) => void;
  updateStep: (step: MethodStep) => void;
  deleteStep: (id: string) => void;
  handleClass: string;
}

export default function RecipeMethodStep({
  step,
  stepName,
  expanded,
  editMode,
  handleExpansionChange,
  updateStep,
  deleteStep,
  handleClass,
}: Props) {
  const { classes } = useStyles();
  const stepRef = useRef(null);

  useEffect(() => {
    if (editMode && expanded && stepRef) {
      setTimeout(() => {
        // scrollToComponent(stepRef, {});
        // window.scrollTo(0, stepRef.current.offsetTop);
        stepRef.current.scrollIntoView(true);
        window.scrollBy({ left: 0, top: -200, behavior: "smooth" });
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepRef, expanded]);

  return (
    <Accordion
      expanded={expanded}
      onChange={(event: any, isExpanded: any) =>
        handleExpansionChange(step.id, isExpanded)
      }
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        classes={{ content: classes.summaryContent }}
      >
        {editMode && <DragHandle className={handleClass} />}
        <Typography className={classes.stepSummary}>{stepName}</Typography>
        {!expanded && (
          <Typography component="div" className={classes.stepPreviewContainer}>
            <div className={classes.stepPreview}>{step.step}</div>
          </Typography>
        )}
      </AccordionSummary>
      <AccordionDetails>
        {editMode ? (
          <TextField
            ref={stepRef}
            autoFocus
            multiline
            fullWidth
            label="Step Details"
            variant="outlined"
            value={step.step}
            // onChange={(event) => setStep(event.target.value)}
            onChange={(event: any) =>
              updateStep({ id: step.id, step: event.target.value })
            }
          />
        ) : (
          <Typography className={classes.step}>{step.step}</Typography>
        )}
      </AccordionDetails>
      {editMode && (
        <AccordionActions>
          <IntentButton
            onClick={() => deleteStep(step.id)}
            variant="contained"
            intent={Intent.ERROR}
            startIcon={<DeleteIcon />}
          >
            Delete
          </IntentButton>
        </AccordionActions>
      )}
    </Accordion>
  );
}
